module.exports = __webpack_public_path__ + "img/logoClaim.940fca56.svg";